const state = {
  fieldList: [], // 字段列表
  instanceCodeOptions: [], // 实例code列表
  screenFieldsFieldList: [] // 人才库高筛字段
}

const mutations = {
  SET_FIELD_LIST(state, vo) {
    state.fieldList = vo
  },
  SET_INSTANCE_CODE_OPTIONS(state, vo) {
    state.instanceCodeOptions = vo
  },
  setScreenFieldsFieldList(state, vo) {
    state.screenFieldsFieldList = vo
  }
}

const actions = {
  setFieldList({ commit }, vo) {
    commit('SET_FIELD_LIST', vo)
  },
  setInstanceCodeOptions({ commit }, vo) {
    commit('SET_INSTANCE_CODE_OPTIONS', vo)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
